// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/services/dispatchReservationService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";


// =============================================================================
// GET DISPATCHABLE RESERVATIONS
// =============================================================================

export async function getDispatchableReservations(
  params = {}
) {

  const response =
    await axiosClient.get(

      "/api/pms/task-material-reservation/dispatchable",

      {
        params
      }
    );

  return response.data;
}